import type Result from 'true-myth/result';

import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { CompanyProfile } from './company-profile';
import { companyProfileSchema } from './company-profile';

export type GenerateCompanyPriorities = () => Promise<Result<CompanyProfile, unknown>>;

const timeout = 60_000;

export const createGenerateCompanyPriorities = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): GenerateCompanyPriorities => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.post(companyProfileSchema, {
            pathname: `/company-profile/generate/priorities`,
            requestOptions: {
                timeout,
            },
        });
    };
};
